/**
 * showToast - 公共 Toast 弹窗，替代 alert
 * @param {string} message  提示内容
 * @param {string} type     类型: 'info' | 'success' | 'error' | 'warning'  默认 'info'
 * @param {number} duration 显示时长(ms)，默认 6000
 */
function showToast(message, type, duration) {
    type = type || 'info';
    duration = duration || 6000;

    var icons = {
        success: '<svg viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5"/><path d="M6 10l3 3 5-5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        error:   '<svg viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5"/><path d="M7 7l6 6M13 7l-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
        warning: '<svg viewBox="0 0 20 20" fill="none"><path d="M10 3L18 17H2L10 3z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M10 9v4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><circle cx="10" cy="14.5" r=".8" fill="currentColor"/></svg>',
        info:    '<svg viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5"/><path d="M10 9v5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><circle cx="10" cy="6.5" r=".8" fill="currentColor"/></svg>'
    };

    var $container = $('#toast-container');
    if (!$container.length) {
        $container = $('<div id="toast-container"></div>');
        $('body').append($container);
    }

    var $toast = $(
        '<div class="toast toast--' + type + '">' +
            '<span class="toast__icon">' + (icons[type] || icons.info) + '</span>' +
            '<span class="toast__msg">' + message + '</span>' +
            '<button class="toast__close" aria-label="Close">' +
                '<svg viewBox="0 0 14 14" fill="none"><path d="M2 2l10 10M12 2L2 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
            '</button>' +
        '</div>'
    );

    $container.append($toast);

    // 入场动画
    setTimeout(function() { $toast.addClass('toast--show'); }, 10);

    var timer = setTimeout(function() { removeToast($toast); }, duration);

    $toast.find('.toast__close').on('click', function() {
        clearTimeout(timer);
        removeToast($toast);
    });
}

function removeToast($toast) {
    $toast.removeClass('toast--show').addClass('toast--hide');
    setTimeout(function() { $toast.remove(); }, 350);
}

/**
 * showModal - 带按钮的提示弹窗
 * @param {object} opts
 *   title    {string}   标题
 *   message  {string}   内容
 *   type     {string}   'info' | 'warning' | 'error' | 'success'
 *   buttons  {Array}    按钮配置，每项支持：
 *     - type: 'primary' | 'secondary'       渲染为 <button>，onClick 回调
 *     - type: 'link'                         渲染为 <a>，需提供 href
 *     - type: 'link-blank'                   渲染为 <a target="_blank">，需提供 href
 */
function showModal(opts) {
    opts = opts || {};
    var type = opts.type || 'info';
    var buttons = opts.buttons || [{ text: 'OK', type: 'primary' }];

    var icons = {
        success: '<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/><path d="M7 12l4 4 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        error:   '<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/><path d="M8 8l8 8M16 8l-8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
        warning: '<svg viewBox="0 0 24 24" fill="none"><path d="M12 4L21 20H3L12 4z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M12 10v5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="17.5" r="1" fill="currentColor"/></svg>',
        info:    '<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/><path d="M12 11v6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="7.5" r="1" fill="currentColor"/></svg>'
    };

    var btnHtml = buttons.map(function(b) {
        if (b.type === 'link' || b.type === 'link-blank') {
            var target = b.type === 'link-blank' ? ' target="_blank" rel="nofollow"' : '';
            return '<a href="' + (b.href || '#') + '" class="modal-btn modal-btn--primary"' + target + '>' + b.text + '</a>';
        }
        var cls = b.type === 'primary' ? 'modal-btn modal-btn--primary' : 'modal-btn modal-btn--secondary';
        return '<button class="' + cls + '">' + b.text + '</button>';
    }).join('');

    var $overlay = $(
        '<div class="modal-overlay">' +
            '<div class="modal-box modal-box--' + type + '">' +
                '<div class="modal-icon">' + (icons[type] || icons.info) + '</div>' +
                (opts.title ? '<h3 class="modal-title">' + opts.title + '</h3>' : '') +
                (opts.message ? '<p class="modal-message">' + opts.message + '</p>' : '') +
                '<div class="modal-actions">' + btnHtml + '</div>' +
            '</div>' +
        '</div>'
    );

    $('body').append($overlay);
    setTimeout(function() { $overlay.addClass('modal-overlay--show'); }, 10);

    function closeModal() {
        $overlay.removeClass('modal-overlay--show');
        setTimeout(function() { $overlay.remove(); }, 300);
    }

    // 所有按钮点击后关闭弹窗，并触发 onClick 回调
    $overlay.find('.modal-btn').each(function(i) {
        var b = buttons[i];
        $(this).on('click', function() {
            closeModal();
            if (typeof b.onClick === 'function') b.onClick();
        });
    });

    // 点遮罩关闭
    $overlay.on('click', function(e) {
        if ($(e.target).is('.modal-overlay')) closeModal();
    });
}
